import type { LocalePrefixMode } from 'next-intl/routing';

const localePrefix: LocalePrefixMode = 'as-needed';

export const AppConfig = {
  name: 'American Avenue Resident Portal Web',
  locales: ['en', 'es'],
  defaultLocale: 'en',
  localePrefix,
};
